import type React from "react"
import { Box, Typography, Paper, Avatar } from "@mui/material"
import FormatQuoteIcon from "@mui/icons-material/FormatQuote"

interface TestimonialCardProps {
  name: string
  location: string
  testimonial: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ name, location, testimonial }) => {
  // Generate initials from name
  const initials = name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()

  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <FormatQuoteIcon
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          fontSize: 40,
          color: "primary.light",
          opacity: 0.2,
        }}
      />

      <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 3 }}>
        "{testimonial}"
      </Typography>

      <Box sx={{ mt: "auto", display: "flex", alignItems: "center" }}>
        <Avatar
          sx={{
            bgcolor: "primary.main",
            width: 50,
            height: 50,
            mr: 2,
          }}
        >
          {initials}
        </Avatar>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            {name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {location}
          </Typography>
        </Box>
      </Box>
    </Paper>
  )
}

export default TestimonialCard
